/*
 * Purpose: Redact secrets from dossier payloads before persist or AI context
 * Last modified: 2026-06-28 | Agent
 * Completeness: 100
 */
import { VAULT_FIELD_MARKER } from '@/services/mission-knowledge/types';

const SECRET_KEY = /(api[_-]?key|secret|token|password|authorization|credential)/i;

export function sanitizeDossierPayload(
  payload?: Record<string, unknown>
): Record<string, unknown> | undefined {
  if (!payload || typeof payload !== 'object') return undefined;

  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(payload)) {
    if (SECRET_KEY.test(key)) {
      out[key] = '[redacted]';
      continue;
    }
    if (typeof value === 'string') {
      if (value.startsWith(VAULT_FIELD_MARKER)) {
        out[key] = '[vault — not logged]';
      } else if (value.length > 4000) {
        out[key] = `${value.slice(0, 4000)}… [truncated]`;
      } else {
        out[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      out[key] = value.slice(0, 50).map((v) =>
        typeof v === 'object' && v !== null
          ? sanitizeDossierPayload(v as Record<string, unknown>)
          : v
      );
      continue;
    }
    if (typeof value === 'object' && value !== null) {
      out[key] = sanitizeDossierPayload(value as Record<string, unknown>);
      continue;
    }
    out[key] = value;
  }
  return out;
}
